var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSolutionCertification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100.375
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Component 40 \\u2013 1"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1604",
  fill: "none",
  d: "M0 .375h100v100H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3284"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Search results for Registration - Flaticon-3"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 7285",
  d: "M92.929 24.946H83.5a2.357 2.357 0 0 0 0 4.714h9.429a2.36 2.36 0 0 1 2.357 2.357v50.286a2.36 2.36 0 0 1-2.357 2.357H8.071a2.36 2.36 0 0 1-2.357-2.357V32.017a2.36 2.36 0 0 1 2.357-2.357H17.5a2.357 2.357 0 0 0 0-4.714H8.071A7.079 7.079 0 0 0 1 32.017v50.286a7.079 7.079 0 0 0 7.071 7.071h24.358v6.286h-8.643a2.357 2.357 0 0 0 0 4.714h53.428a2.357 2.357 0 0 0 0-4.714h-8.643v-6.285h24.358A7.079 7.079 0 0 0 100 82.303V32.017a7.079 7.079 0 0 0-7.071-7.071ZM63.857 95.66H37.143v-6.285h26.714Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 7286",
  d: "m19.32 67.644 3.143 6.286a2.359 2.359 0 0 0 3.9.48l9.429-11a2.357 2.357 0 1 0-3.579-3.069l-7.118 8.305-1.555-3.111a2.357 2.357 0 1 0-4.217 2.109Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 7287",
  d: "M34.786 72.875a2.357 2.357 0 0 0 2.357 2.357h42.429a2.357 2.357 0 1 0 0-4.714H37.143a2.357 2.357 0 0 0-2.357 2.357Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 7288",
  d: "M69.357 1.375H31.642a7.079 7.079 0 0 0-7.071 7.071v37.715a7.079 7.079 0 0 0 7.071 7.071h37.715a7.079 7.079 0 0 0 7.071-7.071V8.446a7.079 7.079 0 0 0-7.071-7.071Zm-5.054 39.809H36.697a2.357 2.357 0 0 1 0-4.714h27.606a2.357 2.357 0 0 1 0 4.714Zm0-11.523H36.697a2.357 2.357 0 0 1 0-4.714h27.606a2.357 2.357 0 0 1 0 4.714Zm0-11.523H36.697a2.357 2.357 0 0 1 0-4.714h27.606a2.357 2.357 0 0 1 0 4.714Z",
  fill: "none",
  stroke: "#000",
  strokeWidth: 2.75
}))))));
export default SvgSolutionCertification;